import Image from "next/image";

import PhoneLink from "@/components/common/links/PhoneLink";
import requestCallbackMobileImage from "@/public/assets/images/mobile-request-callback.jpg";
import requestCallbackImage from "@/public/assets/images/request-call-back.jpg";
import requestCallbackTabImage from "@/public/assets/images/tab-request-callback.jpg";
import { DEFAULT_PLACEHOLDER, phoneNumber } from "@/utils/constants";

import "./styles.css";

const RequestCallbackCard = () => {
  return (
    <>
      <div className="relative mb-3 hidden aspect-[1091/113] w-full overflow-hidden rounded-xl lg:block 2xl:rounded-3xl">
        <Image
          src={requestCallbackImage}
          alt="request-call-back"
          fill
          placeholder="blur"
          blurDataURL={DEFAULT_PLACEHOLDER}
          className="object-cover object-center"
          loading="lazy"
        />
        <PhoneLink
          phoneNumber={phoneNumber}
          linkClassNames="inter absolute right-5 top-1/2 -translate-y-1/2 cursor-pointer rounded-xl bg-white font-semibold hover:bg-[#cba04b] hover:text-white lg:px-3 lg:py-2 2xl:px-5 2xl:py-3"
          buttonClassNames="inter absolute right-5 top-1/2 -translate-y-1/2 cursor-pointer rounded-xl bg-white font-semibold hover:bg-[#cba04b] hover:text-white lg:px-3 lg:py-2 2xl:px-5 2xl:py-3"
        >
          Request a callback
        </PhoneLink>
      </div>

      {/* =================== Mobile =================== */}

      <div className="relative mb-3 block aspect-[373/450] w-full overflow-hidden rounded-3xl sm:hidden">
        {" "}
        <Image
          src={requestCallbackMobileImage}
          alt="request-call-back"
          fill
          placeholder="blur"
          blurDataURL={DEFAULT_PLACEHOLDER}
          className="object-cover object-top"
          loading="lazy"
        />
        <PhoneLink
          phoneNumber={phoneNumber}
          buttonClassNames="inter absolute bottom-3 left-1/2 w-4/5 -translate-x-1/2 cursor-pointer rounded-xl bg-white px-5 py-3 text-center font-semibold hover:bg-[#cba04b] hover:text-white"
          linkClassNames="inter absolute bottom-3 left-1/2 w-4/5 -translate-x-1/2 cursor-pointer rounded-xl bg-white px-5 py-3 text-center font-semibold hover:bg-[#cba04b] hover:text-white"
        >
          Request a callback
        </PhoneLink>
      </div>

      <div className="relative mb-3 block w-full overflow-hidden rounded-3xl sm:block sm:aspect-[373/200] lg:hidden">
        {" "}
        <Image
          src={requestCallbackTabImage}
          alt="request-call-back"
          fill
          placeholder="blur"
          blurDataURL={DEFAULT_PLACEHOLDER}
          className="object-cover object-top"
          loading="lazy"
        />
        <PhoneLink
          phoneNumber={phoneNumber}
          buttonClassNames="inter absolute bottom-3 left-1/2 w-4/5 -translate-x-1/2 cursor-pointer rounded-xl bg-white px-5 py-3 text-center font-semibold hover:bg-[#cba04b] hover:text-white"
          linkClassNames="inter absolute bottom-3 left-1/2 w-4/5 -translate-x-1/2 cursor-pointer rounded-xl bg-white px-5 py-3 text-center font-semibold hover:bg-[#cba04b] hover:text-white"
        >
          Request a callback
        </PhoneLink>
      </div>
    </>
  );
};

export default RequestCallbackCard;
